import styled, { css } from 'styled-components';
import { themeColor } from '../theme/colors';
import { mdLight, smLight } from '../theme/typography';
import { transitionFunc } from '../theme/utils';

export enum StepStatus {
  COMPLETED = 'COMPLETED',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE',
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const StepContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  height: 34px;

  &.tall {
    height: auto;

    // this is an "alternative" connecting line for the case where the step
    // is taller than the circle content
    &::before {
      content: '';
      position: absolute;
      top: 36px;
      left: 17px;
      width: 1px;
      height: calc(100% - 36px);
      background: ${themeColor('strokePrimary')};
    }

    .stepContent {
      padding-top: 7px;
    }

    .stepCircle {
      align-self: start;
    }
  }
`;

const Circle = styled.div<{ status: StepStatus }>`
  transition: border-color 0.5s ${transitionFunc};

  margin-right: 20px;
  flex-shrink: 0;
  width: 34px;
  height: 34px;

  color: ${themeColor('turquoise')};
  border: 1px solid ${themeColor('turquoise')};
  border-radius: 50%;
  background: linear-gradient(180deg, #2f3033 0%, #1e1f21 100%);

  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.status === StepStatus.CURRENT &&
    css`
      background: ${themeColor('backgroundLight')};
      border-width: 1.5px;
    `}

  ${(props) =>
    props.status === StepStatus.INCOMPLETE &&
    css`
      background: ${themeColor('backgroundLight')};
      border-color: ${themeColor('strokePrimary')};
      color: ${themeColor('textPrimary')};
    `}
`;

const ConnectingLine = styled.div<{ status: StepStatus }>`
  margin-left: 17px; // TODO: Create a var and caluclate
  width: 1px;
  min-height: 30px;

  background: linear-gradient(to bottom, #0ffee6, #434547);

  ${(props) =>
    props.status !== StepStatus.COMPLETED &&
    css`
      background: ${themeColor('strokePrimary')};
    `}
`;

const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  a {
    color: ${themeColor('turquoise')};
  }
`;

const Title = styled.div<{ status: StepStatus }>`
  ${mdLight};
  color: ${themeColor('textPrimary')};
  font-size: 15px;

  ${(props) =>
    props.status === StepStatus.CURRENT &&
    css`
      color: ${themeColor('turquoise')};
    `}
`;

const Description = styled.div`
  ${smLight};
  color: ${themeColor('textTertiary')};
`;

export {
  Container,
  StepContainer,
  Circle,
  ConnectingLine,
  StepContent,
  Title,
  Description,
};
